import { AfterViewInit, Directive, ElementRef, EventEmitter, inject, Output } from '@angular/core';

// Services
import { LoggerService } from '../../../core/services/logger/logger.service';

@Directive({
  selector: '[stop-gesture]',
  standalone: false,
})
export class StopGestureDirective implements AfterViewInit {
  @Output() stop: EventEmitter<void> = new EventEmitter<void>();

  private pointerEvents: Array<PointerEvent> = [];
  private oldStartEvent: PointerEvent;
  private oldEndEvent: PointerEvent;

  private readonly el = inject(ElementRef<HTMLCanvasElement>);
  private readonly logger = inject(LoggerService);

  ngAfterViewInit(): void {
    this.logger.consoleLog('StopGestureDirective', 'ngAfterViewInit', this.stop !== undefined);

    const canvas = this.el.nativeElement;
    canvas.draggable = false;
    canvas.style.userSelect = 'none';
    canvas.style.touchAction = 'none';
    canvas.onpointerdown = (event: PointerEvent) => this.pointerupHandler(event);
    canvas.onpointerup = (event: PointerEvent) => this.pointerupHandler(event);
  }

  private pointerupHandler(event: PointerEvent): void {
    if (event.type === 'pointerdown') {
      this.pointerEvents.push(event);
    } else {
      const startEvent = this.pointerEvents.find(({ pointerId }) => event.pointerId === pointerId);
      const endEvent = event;
      if (this.oldStartEvent && this.oldEndEvent) {
        if (this.checkRange(this.oldStartEvent, this.oldEndEvent, startEvent, endEvent)) {
          this.stop.emit();
        }
        this.oldEndEvent = undefined;
        this.oldStartEvent = undefined;
      } else {
        this.oldStartEvent = startEvent;
        this.oldEndEvent = endEvent;
      }
    }
  }

  private checkRange(
    oldStart: PointerEvent,
    oldEnd: PointerEvent,
    newStart: PointerEvent,
    newEnd: PointerEvent,
  ): boolean {
    return (
      this.checkIntersection(oldStart, newStart, newEnd) !== this.checkIntersection(oldEnd, newStart, newEnd) &&
      this.checkIntersection(oldStart, oldEnd, newStart) !== this.checkIntersection(oldStart, oldEnd, newEnd)
    );
  }

  private checkIntersection(pointA: PointerEvent, pointB: PointerEvent, pointC: PointerEvent) {
    return (pointC.y - pointA.y) * (pointB.x - pointA.x) > (pointB.y - pointA.y) * (pointC.x - pointA.x);
  }
}
